/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isMobile = _interopRequireDefault(require("./isMobile"));
var _default = _isMobile.default ? {
  onMouseDown: 'onTouchStart',
  onMouseUp: 'onTouchEnd',
  onMouseMove: 'onTouchMove'
} : {
  onMouseDown: 'onMouseDown',
  onMouseUp: 'onMouseUp',
  onMouseMove: 'onMouseMove'
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/eventNames.js
// module id = 578
// module chunks = 0